"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generatePreviewLink = exports.getPostPreview = exports.getSitePreview = void 0;

var _services = require("../services");

var getSitePreview = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, dispatch, config) {
    var siteID, previewID, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            siteID = _ref.siteID, previewID = _ref.previewID;
            _context.next = 3;
            return _services.previewServices.getSitePreview({
              siteID: siteID,
              previewID: previewID
            }, dispatch, config);

          case 3:
            result = _context.sent;

            if (result) {
              dispatch({
                type: "ADD_SITE",
                payload: result
              });
            }

            return _context.abrupt("return", result);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getSitePreview(_x, _x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}();

exports.getSitePreview = getSitePreview;

var getPostPreview = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, dispatch, config) {
    var siteID, previewID, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            siteID = _ref2.siteID, previewID = _ref2.previewID;
            _context2.next = 3;
            return _services.previewServices.getPostPreview({
              siteID: siteID,
              previewID: previewID
            }, dispatch, config);

          case 3:
            result = _context2.sent;

            if (result) {
              dispatch({
                type: "ADD_EDITOR_POST",
                payload: result
              });
            }

            return _context2.abrupt("return", result);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getPostPreview(_x4, _x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();

exports.getPostPreview = getPostPreview;

var generatePreviewLink = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, dispatch, config) {
    var siteID, postID, expiryDate, result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            siteID = _ref3.siteID, postID = _ref3.postID, expiryDate = _ref3.expiryDate;
            _context3.next = 3;
            return _services.previewServices.generatePreviewLink({
              siteID: siteID,
              postID: postID,
              expiryDate: expiryDate
            }, dispatch, config);

          case 3:
            result = _context3.sent;
            return _context3.abrupt("return", result);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function generatePreviewLink(_x7, _x8, _x9) {
    return _ref6.apply(this, arguments);
  };
}();

exports.generatePreviewLink = generatePreviewLink;